export default __webpack_public_path__ + "static/media/hover.23182bbd.svg";